import React from "react";

const Footer = () => (
    <footer className="Footer">
        <div className="container">
            <div className="row">
                <div className="col-12 text-center pb-2">
                    Copyright &copy; AD-art 2019
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
